import * as React from "react";
import SupportList from "./SupportList";
import { actions } from "@reducers/supportReducer";
import { useDispatch } from "react-redux";
import { useFocusEffect } from "@react-navigation/native";
import { View, BackHandler } from "react-native";

import analytics from "@services/analytics";
import { SUPPORT_FLOW } from "@constants/analyticsEventsCT";

const SupportTree = ({ navigation, route }) => {
  const dispatch = useDispatch();

  const { params } = route;
  const id = (params && params.id) || "CL_MAIN_LIST_V3";
  if (id === "CL_MAIN_LIST_V3") {
    dispatch(actions.setTopLevelScreen(route.key));
  }
  React.useEffect(() => {
    return () => {
      if (!params || !params.id) {
        dispatch(actions.resetSupportTicketPayload());
      }
    };
  }, []);

  useFocusEffect(
    React.useCallback(() => {
      const onBackPress = () => {
        navigation.goBack();
        return true;
      };

      const subscription = BackHandler.addEventListener("hardwareBackPress", onBackPress);

      return () => subscription.remove();
    }, []),
  );

  return <SupportList id={id} isParent={!params || !params.id} />;
};

export default SupportTree;
